import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryPackage3UpHedsOnlyIntegrityProps {
    items?: CuratedItem[] | [];
}

export default function integrityCheck({
    items,
}: StoryPackage3UpHedsOnlyIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
